import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import axios from "axios";
import qs from "qs";
import VueCookies from "vue-cookies";
import VueAxios from "vue-axios";
Vue.use(VueClipboard, VueAxios, axios, VueCookies);
export default {
  name: "guestEmailMacinary",
  data: () => ({
    email: "",
    Token: "",
    node_send: process.env.VUE_APP_NODE_MACINARY,
    error: "",
    allEMail: "",
    loader: "",
  }),
  methods: {
    copyClipboard: function(key, param) {
      var email = document.getElementById(key).textContent;
      var code = document.getElementById(param).textContent;
      let credential = "Email : " + email + " Code Akses : " + code;
      this.$copyText(credential)
        .then(() => {
          alert(credential + " (Telah di copy)");
        })
        .catch(() => {
          alert("copy filed");
        });
    },
    conection: function(url, methods, data) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token,
        },
        data: qs.stringify(data),
        url: this.node_send + url,
      };
      return axios(data_send);
    },
    standartConection: function(url, methods) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token,
        },
        url: this.node_send + url,
      };
      return axios(data_send);
    },

    getCodeEmail: function() {
      this.loader = 2;
      let url = "users/guest";
      let type = "POST";
      let data = {
        email: this.email,
      };
      this.conection(url, type, data)
        .then((response) => {
          if (response) location.reload();
        })
        .catch((error) => {
          this.error = error.response.message;
        });
    },
    getMailList: function() {
      let url = "users/guest";
      let type = "GET";
      this.standartConection(url, type)
        .then((response) => {
          this.allEMail = response.data.result;
        })
        .catch((error) => {
          this.error = error.response.data;
        });
    },
  },

  mounted() {
    this.Token = window.$cookies.get("ACC_MC");
    if (!this.Token) {
      this.$router.push({ path: "/machine" });
    }
    this.getMailList();
  },
};
